import styled from 'styled-components';
import Select from 'react-select';
/** https://react-select.com/props */

export const DefaultSelect = styled(Select)`
  width: 100%;
  font-size: ${(props) => props.fontSize};
  margin: ${(props) => props.margin};
`;

export const setSelectThemeColor = (theme, colorObject) => ({
  ...theme,
  colors: {
    ...theme.colors,
    ...colorObject,
  },
});
